export enum IdStorageTypes {
  MAP_TYPE = 'MAP_TYPE',
  ROUTES = 'ROUTES',
  TRAFFIC = 'TRAFFIC',
  INFO_ROUTE = 'INFO_ROUTE',
}

export enum ValuesStorageTypes {
  MAP = 'ROADMAP',
  SATELLITE = 'HYBRID',
}

const options = [
  {
    id: 'MAP_TYPE',
    value: 'MAP',
  },
  {
    id: 'ROUTES',
    value: true,
  },
  {
    id: 'TRAFFIC',
    value: false,
  },
  {
    id: 'INFO_ROUTE',
    value: false,
  },
];

const MAP_OPTIONS_KEY = 'user_map_setup';

export function setStorageOptions(id: IdStorageTypes, value: ValuesStorageTypes | boolean) {
  options.forEach(item => {
    if (item.id === id) {
      item.value = value;
    }
  });

  sessionStorage.setItem(MAP_OPTIONS_KEY, JSON.stringify(options));
}

export function getStorageOptions(id: IdStorageTypes) {
  const optionsStorage = JSON.parse(sessionStorage.getItem(MAP_OPTIONS_KEY));
  return optionsStorage && optionsStorage.find(item => item.id === id)?.value;
}
